import { Link } from "react-router-dom";
import { Mail, LifeBuoy, FileText } from "lucide-react";
import { studio } from "@/data/site";
import { Reveal, SectionLabel } from "@/components/common/Reveal";

const items = [
  {
    icon: LifeBuoy,
    title: "Support & FAQ",
    body: "Pick your app, read the common answers, or send us a request.",
    to: "/support",
    cta: "Open support",
    testId: "contact-card-support",
  },
  {
    icon: FileText,
    title: "Sources & references",
    body: "Where the educational content in our health apps comes from.",
    to: "/sources",
    cta: "View sources",
    testId: "contact-card-sources",
  },
];

export const ContactSection = () => (
  <section className="py-24 sm:py-32" id="contact" data-testid="home-contact">
    <div className="shell">
      <SectionLabel>Contact</SectionLabel>
      <div className="mt-8 grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-20">
        <div>
          <Reveal>
            <h2 className="font-display text-2xl font-black leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl">
              Questions, problems, ideas — one inbox.
            </h2>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-gray-400 sm:text-base">
              Support is handled by the people who build the apps. Each app has its own support
              address — AuraHealth customer service is below — and we usually reply within 2–3
              business days.
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <a
              href={`mailto:${studio.supportEmail}`}
              data-testid="contact-email-link"
              className="glass mt-8 inline-flex items-center gap-3 rounded-full px-5 py-3.5 transition-colors duration-300 hover:border-[var(--accent)]"
            >
              <Mail className="h-4 w-4" style={{ color: "var(--accent)" }} aria-hidden />
              <span className="font-mono-x text-sm text-white">{studio.supportEmail}</span>
            </a>
          </Reveal>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={i * 0.08}>
              <Link
                to={it.to}
                data-testid={it.testId}
                className="group flex h-full flex-col rounded-3xl p-6 transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-[var(--accent)]"
                style={{ background: "var(--surface)", border: "1px solid var(--line)" }}
              >
                <it.icon className="h-5 w-5" style={{ color: "var(--accent)" }} aria-hidden />
                <h3 className="font-display mt-6 text-lg font-bold text-white">{it.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-gray-400">{it.body}</p>
                <span className="link-underline mt-6 self-start text-xs uppercase tracking-[0.16em] text-white">
                  {it.cta}
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
